import React from 'react';

type ButtonGroupsProps = {
    align?: 'left' | 'right';
    mobileStyle?: 'wrap' | 'space-between';
    className?: string;
}

const ButtonGroups: React.FC<ButtonGroupsProps> = ({ align = 'right', mobileStyle, className, children }): JSX.Element => {
    const classNames = [`text-${align}`, className];

    if (Array.isArray(children) && children.length > 1) {
        classNames.push('d-flex', 'justify-content-between', 'button-group');
    } else {
        classNames.push('d-inline-block', 'align-top', 'button-wrapper');
    }

    if (mobileStyle && mobileStyle === 'wrap') {
        classNames.push('wrap-xs');
    }

    return (
        <div className={classNames.join(' ')}>
            { children }
        </div>
    );
};

export default ButtonGroups;
